import Reveal from '@/pages/zz-review/components/Reveal';

const roles = [
  { name: '讀者', desc: '從閱讀開始，理解生命實踐的地圖。' },
  { name: '實踐者', desc: '把閱讀帶回工作、家庭、關係與每日選擇。' },
  { name: '發起人', desc: '在自己的場域發起實踐，服務與承擔。' },
  { name: '共建者', desc: '參與生命共同體與文明的長程共建。' },
];

export default function InitiatorSection() {
  return (
    <section id="initiator" className="w-full py-16 md:py-24 bg-background-100 scroll-mt-20">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <Reveal>
          <div className="text-center mb-10 md:mb-12">
            <p className="text-xs tracking-[0.2em] uppercase text-foreground-400 mb-3">
              Initiator
            </p>
            <h2
              className="text-2xl md:text-4xl text-foreground-900"
              style={{ fontFamily: 'var(--font-heading)' }}
            >
              生命樹上的角色
            </h2>
          </div>
        </Reveal>

        {/* 核心句（不改寫） */}
        <Reveal delay={60}>
          <div className="rounded-lg border border-primary-200/70 bg-background-50 px-6 md:px-8 py-8 md:py-10 text-center mb-10">
            <p
              className="text-base md:text-xl text-foreground-800 leading-relaxed"
              style={{ fontFamily: 'var(--font-heading)' }}
            >
              維度不是身分勳章。成熟，表現在一個生命能承擔多少實質升維的大生命角色。
            </p>
          </div>
        </Reveal>

        <Reveal delay={100}>
          <p className="text-center text-sm md:text-base text-foreground-600 leading-relaxed max-w-2xl mx-auto mb-10">
            在 AUM1001 Matrix 中，每個生命都從自己的位置開始，逐步承擔更大的角色。角色的進化，是生命成熟最真實的呈現。
          </p>
        </Reveal>

        <Reveal delay={140}>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {roles.map((role) => (
              <div
                key={role.name}
                className="rounded-lg border border-background-200/70 bg-background-50 px-5 py-6 text-center"
              >
                <p
                  className="text-base md:text-lg text-foreground-900 font-medium mb-2"
                  style={{ fontFamily: 'var(--font-heading)' }}
                >
                  {role.name}
                </p>
                <p className="text-sm text-foreground-500 leading-relaxed">{role.desc}</p>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}